/// <reference path="../types/index.d.ts" />

import '../client_forms/rosemary/style.css';
import FormStructure from './rosemary/form_structure';

export default FormStructure;